import { InjectionToken } from '@angular/core';

import { CmsAnalyticsConfig } from 'idt-analytics-api/models';
import { EcommerceConfig } from 'idt-ecommerce-api/config/config.models';
import { ContinentStoresConfig } from 'idt-ecommerce-api/stores/stores.models';


export enum DeviceType {
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_WIDE
}

export interface BreakPoint {
  bp: string;
  name: string;
  device: DeviceType[];
}

export interface StaticMaterializedConfig {
  staticMaterializedUrl: string;
  staticMaterializedUrlChina: string;
}

export interface ExperimentalFeatures {
  enableAnalyticsCMS?: boolean;
  gmapsApiKey?: string;
  timeline?: boolean;
  stylesModule?: boolean;
  resizeObserverInSliceSlider?: boolean;
}

export interface LocalFontSource {
  name: string;
  path: string;
  fontWeight?: string;
  fontStyle?: string;
}

export interface FontsConfig {
  sources: LocalFontSource[];
  domains: {
    default: string;
    [countryCode: string]: string;
  };
}

export interface PageType {
  name: string;
  label: string;
}

export const AppConfigToken = new InjectionToken('app.config');

export interface AppConfig {
  apiEcommerceBaseUrl: string;
  isProduction: boolean;
  amandaImageVideoManagerEnabled: boolean;
  staticMaterializedConfig?: StaticMaterializedConfig;
  ignoreCredentials?: boolean;
  apiMaterializedUrl: string;
  assetsUrl: string;
  ecommerce: EcommerceConfig;
  analytics?: CmsAnalyticsConfig;
  breakpoints: BreakPoint[];
  storesGroup?: ContinentStoresConfig[];
  experimentalFeatures?: ExperimentalFeatures;
  fonts?: FontsConfig;
  pageTypes?: PageType[];
  hasToLockNewConfigurations?: boolean;
}
